<template>

  <section class="plate crp">
    <header class="plate-header" style="height:100px;">
      <h2 style="width:100%;">Condition Risk Profile<br/><span style="color:rgb(0, 153, 191);font-size:.6em">Weekly Averages</span></h2>
    </header>
    <div id="crp"></div>
  </section>

</template>

<script>

import VueHighcharts from 'vue-highcharts';
import More from 'highcharts/highcharts-more';
import Highcharts from 'highcharts';
More(Highcharts);

import Thresh from '@/lib/genThresh';

export default {
  data(){
    return {
      series: []
    }
  },
  props: ['avg'],
  methods: {

    renderCRP(){
      const crpChart = {
        chart: {
            polar: true,
            backgroundColor: 'none',
            type: 'area',
            height: '80%'
        },
        title: false,
        pane: {
            width: '80%',
            height: '350px'
        },
        xAxis: {
            type: 'axis',
            useHtml: true,
            categories: [
              `Temp:<br/>${this.avg.ttp}`,
              `Hum:<br/>${this.avg.hhm}`,
              `IAQ:<br/>${this.avg.iaq}`,
              `eCO2:<br/>${this.avg.co2}`,
              `tVOC:<br/>${this.avg.voc}`
            ],
            tickmarkPlacement: 'off',
            lineWidth: 0,
            text: '{point.data}',
            labels: {
              formatter(){
                let val;
                const cats = ['Temp', 'Hum', 'IAQ', 'eCO2', 'tVOC'];
                const vals = ['ttp', 'hhm', 'iaq', 'co2', 'voc'];
                const cIndex = cats.indexOf(cats.find(c => this.value.toString().includes(c)));
                return vals[cIndex];
              },
              style: {
                color: 'white',
                fontFamily: 'Comfortaa',
                fontSize: '1.2em'
              }
            }
        },
        yAxis: {
          gridLineInterpolation: 'polygon',
          lineWidth: 0,
          min: 0,
          max: 100,
          labels: {
            style: {
              color: 'none',
              fontFamily: 'Comfortaa'
            }
          }
        },
        tooltip: false,
        legend: false,
        credits: false,
        plotOptions: {
          line: {
            dataLabels: {
              color: 'white',
              size: '1.2em'
            }
          }
        },
        series: [
          {
            enableMouseTracking: false,
            data: this.series
          }
        ],
        responsive: {
            rules: [{
                condition: {
                    maxWidth: 450
                },
                chartOptions: {
                    legend: {
                        align: 'center',
                        verticalAlign: 'bottom',
                        layout: 'horizontal'
                    },
                    pane: {
                        size: '60%'
                    }
                }
            }]
        }
      }
      crpChart.series[0] = setSeriesColors(crpChart.series[0], this.avg),
      this.target = Highcharts.chart('crp', crpChart)
    },
    setSeries(){
      const self = this;
      this.series = Object.keys(this.avg).map(aProp => {
        return {
          rdg: aProp,
          data: setRelative(aProp, self.avg[aProp])
        }
      }).reduce((a, i) => a.concat(i.data), []);
    }
  },
  mounted(){
    this.setSeries();
    this.renderCRP();
  }
}

function setRelative(rdg, val){
  switch (rdg){
    case 'ttp':
      return percentHigher(rdg, val, 35);
    break;
    case 'hhm':
      return val
    break;
    case 'iaq':
      return percentHigher(rdg, val, 500);
    case 'voc':
      return percentHigher(rdg, val && val <= .734 ? val : 0, 1, true);
    break;
    case 'co2':
      return percentHigher(rdg, val, 1750);
    break;
  }
}

function percentHigher(rdg, v, d, dec){
  const perc = Math.round((v/d) * 100);
  return perc < 100 ? perc : 100;
}

function setSeriesColors(series, avg){
  const thresh = Thresh;
  const tiers = ['good', 'bad', 'crit'];
  const colors = ['rgba(102, 173, 95, .75)', 'rgba(199, 172, 78, .75)', 'rgba(168, 34, 50, .75)'];
  const lineColors = ['#39e244', '#fccf00', '#ff0000'];
  try {
    Object.keys(avg).forEach(aProp => {
      tiers.forEach((tier, tIndex) => {
        if (
          (thresh[aProp][`${tier}2`] && avg[aProp] >= thresh[aProp][`${tier}2`].min && avg[aProp] <= thresh[aProp][`${tier}2`].max)
          || (avg[aProp] >= thresh[aProp].min && avg[aProp] <= thresh[aProp].max)
        ) {
          series.color = colors[tIndex];
          series.lineColor = lineColors[tIndex];
          series.marker = {fillColor: lineColors[tIndex]};
        }
      });
    });
  } catch(err) {
    console.log(err);
    series.color = 'rgba(0, 153, 191, .75)';
    series.lineColor = '#0077fe';
    series.marker = {fillColor: '#0077fe'};
  }
  return series;
}

</script>

<style>

.crp {
  width: 29%;
}

.crp header {
  height: 10%;
}

#crp {
  width: 100%;
  height: 90%;
  display: flex;
  justify-content: center;
  align-items: flex-start;
}

</style>



// WEBPACK FOOTER //
// src/components/report/CRP.vue